export function getBreakpoint (name) {
  const rawValue =
    getComputedStyle(document.documentElement)
      .getPropertyValue(`--breakpoint-${name}`)
  return parseInt(rawValue)
}
